import { CSSProperties } from "react";
import styles from "./LoadingDots.module.scss";

interface LoadingDotsProps {
  style?: CSSProperties;
}

export function LoadingDots({ style }: LoadingDotsProps) {
  return <div style={style} className={styles.loader}></div>;
}
